var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgAssets11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.66 13.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ffd510;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.11,4.44c.12,0,.23-.1.23-.23v-1.86c0-.65.49-1.15,1.08-1.16h2.84c.58,0,1.07.51,1.07,1.16v1.86c0,.12.1.23.23.23s.23-.1.23-.23v-1.86c0-.88-.67-1.6-1.53-1.61h-2.84c-.85,0-1.52.73-1.53,1.61v1.86c0,.12.1.23.23.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,5.35h0s0,0,0,0c0,0,0,0-.02,0H1.67c-.68,0-1.19.61-1.19,1.31v4.75c0,.71.51,1.31,1.19,1.31h6.33c.68,0,1.19-.61,1.19-1.31v-4.75c0-.7-.51-1.31-1.18-1.31ZM8.73,11.41c0,.25-.09.47-.23.62-.14.15-.32.24-.51.24H1.67c-.2,0-.37-.09-.51-.24-.14-.15-.23-.37-.23-.62v-4.75c0-.25.09-.47.23-.62.14-.15.32-.24.51-.24h6.33s0,0,0,0c.19,0,.37.09.5.24.14.15.23.37.23.62v4.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgAssets11);
export default __webpack_public_path__ + "static/media/SVG_assets-11.1d560c63aefa7e7a650e5bcc6e8186f4.svg";
export { ForwardRef as ReactComponent };